export default {"lang":{"current":"fr"},"theme":{"dark":false,"themes":{"light":{"primary":"#faea83","secondary":"#afddd2","accent":"#ffeb3b","error":"#ee1d4d","warning":"#fbc156","info":"#faea83","success":"#8bc34a"}}}}
